var render = function render() {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [_vm.$route.meta.keepAlive ? _c('router-view') : _vm._e()], 1), _vm._v(" "), !_vm.$route.meta.keepAlive ? _c('router-view', {
    key: _vm.routerViewKey
  }) : _vm._e(), _vm._v(" "), _vm.$route.meta.showTabbar ? _c('van-tabbar', {
    staticClass: "lyTabbar",
    attrs: {
      "route": ""
    }
  }, [_c('van-tabbar-item', {
    attrs: {
      "replace": "",
      "to": {
        path: '/productsListLy',
        query: {
          tags: _vm.tags
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn(props) {
        return _c('img', {
          staticClass: "tab-bar-img",
          attrs: {
            "src": props.active ? _vm.homeIcon.active : _vm.homeIcon.inactive
          }
        });
      }
    }], null, false, 840112865)
  }, [_c('span', {
    staticClass: "tab-bar-tit"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('van-tabbar-item', {
    attrs: {
      "replace": "",
      "to": {
        path: '/lyMy'
      }
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn(props) {
        return _c('img', {
          staticClass: "tab-bar-img",
          attrs: {
            "src": props.active ? _vm.myIcon.active : _vm.myIcon.inactive
          }
        });
      }
    }], null, false, 1078390049)
  }, [_c('span', {
    staticClass: "tab-bar-tit"
  }, [_vm._v("我的")])])], 1) : _vm._e(), _vm._v(" "), _vm.$route.meta.isHomeIcon ? _c('i', [_c('img', {
    staticClass: "backHomeCls",
    attrs: {
      "src": require("./assets/backHome.png"),
      "alt": ""
    },
    on: {
      "click": _vm.backHomeEvt
    }
  })]) : _vm._e()], 1);
};
var staticRenderFns = [];
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dcf27b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 